import React from "react";
import ClickableImage from "./ClickableImage";
import "./App.css";

function App() {
  return (
    <div className="App">
      <ClickableImage />
    </div>
  );
}

export default App;
